import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { CreditCardsService } from './credit-cards.service';
import { LoaderService } from './loader.service';
import { SepaMandateService } from './sepa-mandate.service';

@Injectable({ providedIn: 'root' })
export class PaymentMeansResolver implements Resolve<any> {
  constructor(
    private creditCardsService: CreditCardsService,
    private sepaMandateService: SepaMandateService,
    private loaderService: LoaderService
  ) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    this.loaderService.increaseLoaderCount();
    const cardsList$Tab = this.creditCardsService.fetchAllCreditCards();
    const sepaMandateList$ = this.sepaMandateService.fetchSepaMandatesList();
    const listSuppliersSepaInProgress$ = this.sepaMandateService.fetchSupplierListSignSepaInProgress();
    return forkJoin([...cardsList$Tab, sepaMandateList$, listSuppliersSepaInProgress$]);
  }
}
